<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'table'">
    <app-template [title]="'QC Table'">
      <div class="search" style="padding-top: 30px">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="" [(ngModel)]="searchQuery" />
          </mat-form-field>
        </span>
        <span>
          <button
            style="margin-bottom: 30px; margin-left: 30px; margin-top: 15px"
            mat-raised-button
            color="primary"
            (click)="searchName(searchQuery)"
          >
            Search
          </button>
        </span>
        <span>
          <button
            style="margin-bottom: 30px; margin-left: 30px; margin-top: 15px"
            mat-raised-button
            color="primary"
            (click)="openModal()"
          >
            Add QC
          </button>
        </span>
      </div>
      <div class="data">
        <div *ngIf="isLoading" style="margin-top: 50px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Id</th>
            <th>Parameter Name</th>
            <th>Unit</th>
            <th>Start Date</th>
            <th>End Date</th>
            <!-- <th>Max</th>
            <th>Normal</th>
            <th>Min</th> -->

            <th></th>
          </tr>
          <tr *ngFor="let item of qcData" style="cursor: pointer">
            <td>{{ item.Id }}</td>
            <td>{{ item.Name }}</td>
            <td>
              {{ item.Unit }}
            </td>
            <td>{{ item.StartDate | date : "longDate" }}</td>
            <td>{{ item.StopDate | date : "longDate" }}</td>
            <!-- <td>{{ item.Max }}</td>
            <td>{{ item.Normal }}</td>
            <td>{{ item.Min }}</td> -->
            <td>
              <button
                (click)="getQcValue(item)"
                mat-raised-button
                color="primary"
              >
                View
              </button>
            </td>
          </tr>
        </table>
      </div>
    </app-template>
  </div>

  <div *ngSwitchCase="'graph'">
    <app-template [title]="'QC Graph'">
      <span>
        <button
          style="margin-bottom: 30px; margin-left: 30px; margin-top: 15px"
          mat-raised-button
          color="primary"
          (click)="back()"
        >
          Back
        </button>
        <br />
        <!-- <input
          type="date"
          [(ngModel)]="startDate"
          (change)="updateDateRange()"
        />
        <input type="date" [(ngModel)]="endDate" (change)="updateDateRange()" /> -->
        <span class="form">
          <mat-form-field class="size" style="margin-right: 20px">
            <mat-label>Start Dates</mat-label>
            <input
              [(ngModel)]="start"
              matInput
              [matDatepicker]="dob"
              (dateChange)="startDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dob"
            ></mat-datepicker-toggle>
            <mat-datepicker #dob></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="form">
          <mat-form-field class="size">
            <mat-label>End Date</mat-label>
            <input
              [(ngModel)]="endd"
              matInput
              [matDatepicker]="end"
              (dateChange)="endDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="end"
            ></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
          </mat-form-field>
        </span>
        <button
          style="margin-bottom: 30px; margin-left: 30px; margin-top: 15px"
          mat-raised-button
          color="primary"
          (click)="updateDateRange()"
        >
          Search
        </button>
      </span>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <div style="font-size: 20px; font-weight: 700">{{ chartName }}</div>
          <div style="font-size: 20px; font-weight: 700">
            {{ chartStartDate }} -
            {{ chartStopDate }}
          </div>
        </div>

        <div style="display: flex">
          <!-- <button
            style="margin-bottom: 30px; margin-left: 15px; margin-top: 15px"
            mat-raised-button
            color="primary"
            (click)="full()"
          >
            Full
          </button>
          <button
            style="margin-bottom: 30px; margin-left: 15px; margin-top: 15px"
            mat-raised-button
            color="primary"
            (click)="high()"
          >
            High
          </button>
          <button
            style="margin-bottom: 30px; margin-left: 15px; margin-top: 15px"
            mat-raised-button
            color="primary"
            (click)="low()"
          >
            Low
          </button> -->
        </div>
      </div>
      <br /><br />
      <div
        id="chartContainer"
        style="height: 520px; width: 100% !important"
      ></div>
      <br /><br />
      <!-- [style.display]="fullVisi ? 'block' : 'none'" -->

      <div
        id="uclChartContainer"
        style="height: 520px; width: 100% !important"
      ></div>
      <br /><br />
      <!-- [style.display]="highVisi ? 'block' : 'none'" -->

      <div
        id="lclChartContainer"
        style="height: 520px; width: 100% !important"
      ></div>
      <!-- [style.display]="lowVisi ? 'block' : 'none'" -->
    </app-template>
  </div>
</div>
